import { ITransactions } from "features/Crm/modules/Transactions/Transactions.interfaces";
import { getMaskedAadhaar } from "utils/aadhaar";
import React from "react";

export const KYCDetailsField = ({
  answers,
  aadhaarNumber,
}: {
  answers: ITransactions.BookingResponse["answer_list"];
  aadhaarNumber?: string | null;
}) => {
  const maskedAadhaar = getMaskedAadhaar(aadhaarNumber);

  return (
    <div className="tw-text-sm">
      {answers.map(({ question, answer }) => (
        <div key={question}>
          <strong>{question}</strong>: {answer}
        </div>
      ))}
      {maskedAadhaar && (
        <div>
          <strong>Aadhaar Number</strong>: {maskedAadhaar}
        </div>
      )}
    </div>
  );
};
